/** 是否是 ip 地址访问  */
function isValidIP(ip) {
    var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]):(\d*)$/
    return reg.test(ip);
}
/** 请求 api 的判断  所有项目的通用*/
const getRequestAddress = ()=>{
    let host = location.host;

    let apiUrl = 'https://course.iwords.top';

    // dev 环境  | 本地环境
    if(host.indexOf('dev-') > -1 || host.indexOf('localhost:') > -1 || isValidIP(host)){
        // apiUrl = 'http://www.iwords.top';
        apiUrl = 'http://127.0.0.1';
    }
    return apiUrl;
};



/**

 */
export const axiosConfig  = {
    requestAddress:getRequestAddress(),
    // shareAddress:getH5Address(),
    /* https://devapi.iqcspace.com/iotp*/
    timeOut:10000,
    filterStatus:[100,200],
    passCode:0,
    errorCode:-1,
    headers:{
        // saas的登录splitKey 只适用于saas平台
        // splitKey:()=>{return '1233452345742423412'},
        // userId: ()=> {return '11222'},
        // appId:()=>{return localStorage.getItem('appId')},
        // appId:()=>{return '15yz'},
        Authorization:()=>{return localStorage.getItem('token')},
        // Authorization:()=>{return 'cc40b257d738387c94a92bae9b81219a'},
    }
};



